import { useLang } from '@/i18n';
import EcoWhatInBox from 'eco-design/sections/eco-what-in-box';
export default function Comp() {
    const { t } = useLang('theProduct');
    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744351581073/1.png',
            title: t('O_tab2_text1'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744702904752/Add-On%20Battery%20Cable.png',
            title: t('O_tab2_text2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744351581218/3.png',
            title: t('O_tab2_text3'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744351581433/4.png',
            title: t('O_tab2_text4'),
        },
    ];
    return (
        <>
            <EcoWhatInBox items={itemsA} />
        </>
    );
}
